import React, { useEffect, useState } from 'react';
import Dialog from 'screens/shared/dialog';
import { Button } from '@mui/material';
import { VERSION_DESCRIPTIONS } from 'constant';
import { _t, compareDCDVersions, getCurrentLanguage } from 'utils';

export default () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const lastVersion = window.localStorage.getItem('lastVersion');
    const currentVersion = process.env.REACT_APP_VERSION;
    if (!lastVersion || !compareDCDVersions(lastVersion, currentVersion)) {
      setShow(true);
      window.localStorage.setItem('lastVersion', currentVersion);
    }
  }, []);

  return (
    <Dialog
      title={_t('WHATS_NEW.TITLE')}
      show={show}
      content={(
        <div>
          {
            VERSION_DESCRIPTIONS.map((item, key) => (
              <div key={key}>
                <h4>{item.title}</h4>
                <div className="versionDescription">{item.description[getCurrentLanguage()]}</div>
              </div>
            ))
          }
        </div>
      )}
      isCloseButton
      style={{ maxHeight: 500, overflowY: 'auto' }}
      actions={(
        <Button variant="contained" color="primary" onClick={() => setShow(false)}>
          OK
        </Button>
      )}
      closeHandler={() => setShow(false)}
    />
  );
};
